import ChartingHighchartsBaseController from './charting_highcharts_base_controller';

export default class extends ChartingHighchartsBaseController {
  buildConfig() {
    const config = super.buildConfig();

    if (!config.yAxis) config.yAxis = {};
    if (!config.yAxis.stops) {
      config.yAxis.stops = [
        [0.3, this.theme('color-error')],
        [0.6, this.theme('color-warning')],
        [0.9, this.theme('color-success')]
      ];
    }

    if (config.yAxis.plotLines) {
      config.yAxis.plotLines = config.yAxis.plotLines.map((line) => ({
        color: this.theme('color-base-content'),
        ...line
      }));
    }

    return config;
  }
}
